module.exports = __webpack_public_path__ + "img/gadgets.f7dca1b1.jpg";